import { isNil } from 'lodash'
import sortBy from 'lodash/sortBy'
import moment from 'moment'

import type { ContractVersion } from 'modules/attendance/lib/contractsVersionContext'

const sortByEffectiveOn = (contracts: ContractVersion[]) =>
  sortBy(contracts, (cv) => cv.effectiveOn)

const contractWithinDateRange = (
  contracts: ContractVersion[],
  startDate: moment.Moment,
  endDate: moment.Moment
) => {
  const sortedByEffectiveOn = sortByEffectiveOn(contracts)

  return sortedByEffectiveOn.filter(
    (cv, index) =>
      moment(cv.effectiveOn).isSameOrBefore(endDate, 'day') &&
      (index === sortedByEffectiveOn.length - 1 ||
        moment(sortedByEffectiveOn[index + 1]?.effectiveOn).isAfter(startDate, 'day'))
  )
}

const isTerminated = (endsOn: moment.Moment, date: moment.Moment) => {
  return !isNil(endsOn) && endsOn.isBefore(date)
}

const getUpcoming = (contracts: ContractVersion[], date: moment.Moment) => {
  const future = contracts.filter((cv) => moment(cv.effectiveOn).isAfter(date))

  return sortByEffectiveOn(future)[0]
}

export const getReferenceContract = (contracts: ContractVersion[]): ContractVersion | undefined => {
  const today = moment()
  const currentVersions = contractWithinDateRange(contracts, today, today)
  const currentNotTerminated = currentVersions.filter(
    (cv) => !isTerminated(moment(cv.endsOn), today)
  )[0]

  if (!!currentNotTerminated) return currentNotTerminated

  const upcoming = getUpcoming(contracts, today)

  if (upcoming) return upcoming

  return currentVersions[0]
}

export const isPastContract = (endsOn: moment.Moment | undefined) => {
  return !!endsOn && endsOn.isBefore(moment(), 'day')
}

export const isFutureContract = (startsOn: moment.Moment | undefined) => {
  return !!startsOn && startsOn.isAfter(moment(), 'day')
}

export const isDailyContract = (contract: ContractVersion | undefined) => !!contract?.frForfaitJours

const sortContractVersions = (contractVersions: ContractVersion[]): ContractVersion[] => {
  const today = moment().toString()

  return contractVersions.sort(
    (a, b) =>
      new Date(a?.startsOn ? a?.startsOn : today).getTime() -
      new Date(b?.startsOn ? b?.startsOn : today).getTime()
  )
}

export const getPreviousContract = (
  referenceContract: ContractVersion | undefined,
  contractVersions: ContractVersion[]
): ContractVersion | undefined => {
  const sortedColl = sortContractVersions(contractVersions)

  const currentIndex = sortedColl.findIndex((cv) => cv.id === referenceContract?.id)

  return sortedColl[currentIndex - 1]
}
